/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export function toTitleCase(str) {
    if (str) {
        return str.replace(/\w*/g, (txt) => {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    }
    return str;
}

export function decodeHTML(html) {
    if (html) {
        let newHTML = html;
        newHTML = newHTML.replace('&#257;', 'ā');
        newHTML = newHTML.replace('&#39;', "'");
        newHTML = newHTML.replace('&amp;', '&');
        newHTML = newHTML.replace('&nbsp;', ' ');
        newHTML = newHTML.replace('&lt;', '<');
        newHTML = newHTML.replace('&gt;', '>');
        return newHTML;
    }

    return html;
}

export function formatLocationName(name) {
    if (name) {
        return toTitleCase(decodeHTML(name));
    }

    return null;
}

export function formatItemName(item) {
    let name = item.name;
    if (item.entity_id) {
        name = toTitleCase(formatLocationName(name));
    } else {
        // try to calculate a shorter name from mapbox address
        const parts = name.split(',');
        if (parts.length > 3) {
            name = parts[0];
        } else {
            name = name.split(',').slice(0, 2).join(', ');
        }
    }
    return name;
}
